<div
  class="text-field"
  [class.text-field-disabled]="disabled"
  [class.text-field-without-hover]="withoutHover"
  (click)="inputElement.focus()"
>
  <span class="text-field__placeholder" *ngIf="placeholder && !label">{{placeholder}}</span>
  <span
    class="text-field__label"
    *ngIf="label"
    [class.text-field__label-without-divider]="withoutDivider"
  >
    {{label}}
  </span>

  <input
    #inputElement
    [formControl]="controlValue"
    [readonly]="disabled"
    class="text-field__input"
    type="text"
  >
</div>
